import { createFileRoute } from "@tanstack/react-router";
import { LoginForm } from "./-components/LoginForm";
import { ResetPasswordForm } from "./-components/ResetPasswordForm";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { createSEOHead, SEO_DATA } from "@/lib/seo";

export const Route = createFileRoute("/(public)/(auth)/connexion")({
  head: () => createSEOHead(SEO_DATA.LOGIN),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <section className="container mx-auto margin-top w-full px-4">
      <header className="text-center mb-8">
        <h1 className="font-h1 mb-4">Connexion à votre compte HomeToQ</h1>
        <p className="font-h4 text-muted-foreground">
          Accédez à votre espace personnel
        </p>
      </header>
      <Tabs defaultValue="account" className="max-w-[500px] mx-auto">
        <TabsList className="grid w-full grid-cols-2 h-fit">
          <TabsTrigger value="account" className="font-h4">
            Connexion
          </TabsTrigger>
          <TabsTrigger value="password" className="font-h4">
            Mot de passe oublié
          </TabsTrigger>
        </TabsList>

        <TabsContent value="account">
          <LoginForm />
        </TabsContent>

        <TabsContent value="password">
          <ResetPasswordForm />
        </TabsContent>
      </Tabs>
    </section>
  );
}
